import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin } from 'lucide-react';
import Logo from './Logo';

const Footer = () => {
  return (
    <footer className="dark-footer">
      <div className="footer-content">
        <div className="footer-grid">
          {/* Company Info */}
          <div className="footer-section">
            <Logo size="small" />
            <p className="footer-text" style={{ marginTop: '16px' }}>
              International bauxite trading connecting Guinea's premium reserves to global aluminum producers.
            </p>
            <div className="footer-social">
              <a href="https://www.linkedin.com/company/spacegems" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="LinkedIn">
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/resources">Resources</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h4 className="footer-heading">Services</h4>
            <ul className="footer-links">
              <li><Link to="/services">Bauxite Trading</Link></li>
              <li><Link to="/services">Supply Chain Management</Link></li>
              <li><Link to="/services">Quality Consulting</Link></li>
              <li><Link to="/services">Market Analysis</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4 className="footer-heading">Contact</h4>
            <ul className="footer-contact">
              <li>
                <Mail size={16} />
                <span>sales@spacegems.io</span>
              </li>
              <li>
                <Phone size={16} />
                <span>+1 (347) 699-0915</span>
              </li>
              <li>
                <MapPin size={16} />
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  <span>Ratoma, Conakry, Guinea</span>
                  <span>399 East 8th Street, New York, NY USA</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 SpaceGems. All rights reserved.</p>
          <div className="footer-bottom-links">
            <a href="#">Privacy Policy</a>
            <a href="#">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;